import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderRailyTaxiRecalculateResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderRailyTaxiRecalculateResponseDataContractTaxiCompany = {
  companyName: string;
};

export type BillingsOrderRailyTaxiRecalculateResponseDataContract = {
  model: BillingsOrderRailyTaxiRecalculateResponseDataContractBillingModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  taxiCorporation: BillingsOrderRailyTaxiRecalculateResponseDataContractTaxiCompany;
};

export type BillingsOrderRailyTaxiRecalculateResponseDataBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate?: Date;
  checkoutEventId?: string;
  plannedDate?: Date;
  orderId?: string;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsOrderRailyTaxiRecalculateResponseDataCargoOrder = {
  humanId: number;
};

export enum BillingsOrderRailyTaxiRecalculateResponseDataPenaltyType {
  OPTIMIZATION_REFUSED = "OPTIMIZATION_REFUSED",
  BEING_LATE = "BEING_LATE",
  INCOMPATIBLE_CAR = "INCOMPATIBLE_CAR",
  HIGHWAY_NOT_ALLOWED = "HIGHWAY_NOT_ALLOWED",
  SUBOPTIMAL_RIDE = "SUBOPTIMAL_RIDE",
  GUIDELINE_IGNORED = "GUIDELINE_IGNORED",
  OTHER = "OTHER",
}

export enum BillingsOrderRailyTaxiRecalculateResponseDataBonusType {
  DISTANCE_RATE_CHANGED = "DISTANCE_RATE_CHANGED",
  HALTING_RATE_CHANGED = "HALTING_RATE_CHANGED",
  SHORT_ROUTE = "SHORT_ROUTE",
  OTHER = "OTHER",
}

export type BillingsOrderRailyTaxiRecalculateResponseData = {
  contract: BillingsOrderRailyTaxiRecalculateResponseDataContract;
  billingNodes: BillingsOrderRailyTaxiRecalculateResponseDataBillingNode[];
  totalAmount: number;
  haltingAmount: number;
  highwayCharge: number;
  distance: number;
  distanceAmount: number;
  cargoOrder: BillingsOrderRailyTaxiRecalculateResponseDataCargoOrder;
  planEntryId: string;
  bonus: number;
  penalty: number;
  penaltyType?: BillingsOrderRailyTaxiRecalculateResponseDataPenaltyType;
  bonusType?: BillingsOrderRailyTaxiRecalculateResponseDataBonusType;
  date: Date;
};

type BillingsOrderRailyTaxiRecalculateResponse =
  HttpResponse<BillingsOrderRailyTaxiRecalculateResponseData>;

export default BillingsOrderRailyTaxiRecalculateResponse;
